export enum TimeOptionsEnums {
    Morning = 'Morning (09:00 - 12:00)',
    Afternoon = 'Afternoon (12:00 - 15:00)',
    LateAfternoon = 'Late afternoon (15:00 - 18:00)',
    Evening = 'Evening (18:00 - 20:00)',
}

export enum UserRoleEnum {
    Support = 'support',
    Advisor = 'advisor',
    Notary = 'notary',
    Bookkeeper = 'bookkeeper',
    Client = 'client',
    Corporate = 'corporate',
    system = 'system',
    Provider = 'provider',
}
